export default function getExtraAttacksUnavailableMessage(previousSubStatus = '') {
  return previousSubStatus === 'Awaiting Extra Attacks'
    ? 'Extra attacks no longer available'
    : 'No extra attacks available'
}
